import React, { useContext } from 'react';
import { View } from 'react-native';

import ClientContext from 'app/src/contexts/ClientContext';
import useScreenSize from 'app/src/hooks/useScreenSize';
import { Title, Text } from 'app/src/styles';

const Home = () => {
  const { currentUser } = useContext(ClientContext);

  const { isScreenSize, isExactScreenSize, aboveScreenSize } = useScreenSize();
  const checkSize = 'full';
  console.log('is', checkSize, isScreenSize(checkSize));

  return (
    <View>
      <Title>KeepingCare</Title>
      <Text>Welcome, {currentUser?.name}</Text>
    </View>
  );
};

export default Home;
